export enum MANAGEMENT_FRAME_BREAKPOINT {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
